import { render, staticRenderFns } from "./ProcessExceptionPreview.vue?vue&type=template&id=da2f843c&scoped=true"
import script from "./ProcessExceptionPreview.vue?vue&type=script&lang=js"
export * from "./ProcessExceptionPreview.vue?vue&type=script&lang=js"
import style0 from "./ProcessExceptionPreview.vue?vue&type=style&index=0&id=da2f843c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2f843c",
  null
  
)

export default component.exports